import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Chip,
  IconButton,
  Tooltip,
  Button
} from '@material-ui/core';
import {
  Copy as CopyIcon,
  ToggleLeft as InactiveIcon,
  ToggleRight as ActiveIcon,
  Trash2 as DeleteIcon,
  ExternalLink as ExternalIcon
} from 'react-feather';
import swal from 'sweetalert';

const LinksListResults = ({ regs, page, setPage, perPage, setPerPage, total, onToggleActive, onDelete, ...rest }) => {
  const handleLimitChange = (event) => {
    setPerPage(event.target.value);
    setPage(1);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    swal('Copiado!', 'Link copiado para área de transferência', 'success');
  };

  const buildFullLink = (link) => {
    // Constrói o link completo com UTM
    const url = new URL(link.target_url);
    url.searchParams.set('utm_source', 'affiliate');
    url.searchParams.set('utm_medium', 'referral');
    url.searchParams.set('utm_campaign', link.code);
    url.searchParams.set('ref', link.code);
    return url.toString();
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>URL de Destino</TableCell>
                <TableCell>Canal</TableCell>
                <TableCell align="center">Vendas</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Criado em</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {regs.map((link) => {
                const fullLink = buildFullLink(link);
                return (
                  <TableRow hover key={link.id}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography color="textPrimary" variant="body1" sx={{ fontWeight: 'bold' }}>
                          {link.code}
                        </Typography>
                        <Tooltip title="Copiar código">
                          <IconButton size="small" onClick={() => copyToClipboard(link.code)}>
                            <CopyIcon size={14} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography color="textPrimary" variant="body2" noWrap>
                        {link.target_url}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          startIcon={<CopyIcon size={14} />}
                          onClick={() => copyToClipboard(fullLink)}
                        >
                          Copiar Link Completo
                        </Button>
                        <Tooltip title="Abrir link">
                          <IconButton size="small" onClick={() => window.open(fullLink, '_blank')}>
                            <ExternalIcon size={14} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography color="textPrimary" variant="body2">
                        {link.channel?.name || 'N/A'}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      {/* eslint-disable-next-line */}
                      <Chip label={link.__meta__?.sales_count || 0} color="primary" size="small" />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={link.active ? 'Ativo' : 'Inativo'}
                        color={link.active ? 'primary' : 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{moment(link.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                        <Tooltip title={link.active ? 'Desativar' : 'Ativar'}>
                          <IconButton
                            size="small"
                            color={link.active ? 'primary' : 'primary'}
                            onClick={() => onToggleActive(link.id, link.active)}
                          >
                            {link.active ? <InactiveIcon size={18} /> : <ActiveIcon size={18} />}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Deletar">
                          <IconButton size="small" color="primary" onClick={() => onDelete(link.id)}>
                            <DeleteIcon size={18} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page - 1}
        rowsPerPage={perPage}
        rowsPerPageOptions={[10, 25, 50, 100]}
        labelRowsPerPage="Registros por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`}
      />
    </Card>
  );
};

LinksListResults.propTypes = {
  regs: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  perPage: PropTypes.number.isRequired,
  setPerPage: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  onToggleActive: PropTypes.func,
  onDelete: PropTypes.func
};

export default LinksListResults;
